export default __webpack_public_path__ + "static/media/report-downloading.101f6be5.svg";